import styled from 'styled-components'

export const StyledTable = styled.table<{ $columns: number }>`
  width: calc(100% + 16px);
  margin: 0 -8px;

  td,
  th {
    padding: 8px;
    width: ${({ $columns = 1 }) => `calc(100% / ${$columns})`};
    vertical-align: top;
  }
`

export const StyledTableSummary = styled.th`
  text-align: right;
  font-size: 18px;
  padding: 0 8px;
  line-height: 20px;
`
